exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.noteButtonCss[data-v-72584e6a] {\n  padding-right: 0px;\n  width: 100%;\n}\n.noteButtonCss button[data-v-72584e6a] {\n  width: 100px !important;\n}\n\n", "", {"version":3,"sources":["/app/src/pages/admin/BusinessNotes.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,wBAAwB;CACzB","file":"BusinessNotes.vue","sourcesContent":["\n.noteButtonCss[data-v-72584e6a] {\n  padding-right: 0px;\n  width: 100%;\n}\n.noteButtonCss button[data-v-72584e6a] {\n  width: 100px !important;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72584e6a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/BusinessNotes.vue
// module id = nbdk
// module chunks = 4